import React from 'react';
import BillingInformation from '@buyside/components/presentation/UserAccount/BillingInformation/billingInformation';

import styles from './billingInformationShowPageStyles.scss';

const BillingInformationShowPage: React.FC = (): React.ReactElement => (
  <>
    <div className={styles.pageTitle}>Billing Information</div>
    <BillingInformation />
  </>
);

export default BillingInformationShowPage;
